// ArticalWrap.js

import {
  defineComponent,
  toRefs,
  ref,
  watch,
  computed,
  inject,
} from "/Scripts/vue.esm-browser.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
import FilterPanel from "/Component/Shop/filter/FilterPanel.js";
import ProductCard from "/Component/Shop/product/ProductCard.js";
import LocationArea from "/Component/Promotions/Keyword/product/LocationArea.js";
import FilterTag from "/Component/Promotions/Keyword/filter/FilterTag.js";
const html = String.raw;

export default defineComponent({
  name: "ArticalWrap",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    groupData: {
      type: Array,
      required: true,
    },
    resetFilters: {
      type: Function,
      required: true,
    },
    filteredDataByGroup: {
      type: Array,
      required: true,
    },
  },
  inject: ["groupShowType"],
  emits: ["update:filters", "reset-filters"],
  components: {
    FilterPanel,
    ProductCard,
    LocationArea,
    FilterTag,
  },
  setup(props, { emit }) {
    // Reactive state for filter panel visibility
    const isFilterOpen = ref(true);
    const { groupData, resetFilters, filteredDataByGroup } = toRefs(props);
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const isLoading = inject("loading");
    const filterCount = inject("filterCount");
    const dept = inject("dept");

    // Create a local copy of filters that can be modified
    // Create a local copy of filters that can be modified
    const localFilters = ref({ ...props.filters });

    // Watch for changes in props.filters and update localFilters
    watch(
      () => props.filters,
      (newFilters) => {
        localFilters.value = { ...newFilters };
      },
      { deep: true },
    );

    // When localFilters changes, emit an event to update parent's filters
    watch(
      localFilters,
      (newFilters) => {
        emit("update:filters", newFilters);
      },
      { deep: true },
    );

    const totalFilterNum = computed(() => {
      let count = 0;
      const [min, max] = props.filters.priceRange;
      const [defaultMin, defaultMax] = props.filters.defaultPriceRange;
      const [start, end] = props.filters.dateRange;
      const [defaultStart, defaultEnd] = props.filters.defaultDateRange;

      if (min !== defaultMin || max !== defaultMax) {
        count++;
      }
      if (start !== defaultStart || end !== defaultEnd) {
        count++;
      }
      count += Array.from(props.filters.selectedWeekdays).length;
      count += Array.from(props.filters.selectedAirlines).length;
      count += props.filters.dayRanges.filter((range) => range.active).length;
      count += props.filters.featureTags.size;

      return count;
    });
    watch(
      () => totalFilterNum.value,
      (newFilters) => {
        console.log(newFilters);
        filterCount.value = newFilters;
      },
      { deep: true },
    );

    // Handle filter toggle
    const toggleFilter = () => {
      isFilterOpen.value = !isFilterOpen.value;
    };
    return {
      filters: localFilters, // Use the local copy instead
      data: groupData,
      resetFilters,
      filteredDataByGroup,
      isFilterOpen,
      toggleFilter,
      mobileFilterPopup,
      filterCount,
      isLoading,
      dept
    };
  },

  template: html`
    <!-- Template remains the same -->
    <div
      class="artical_wrap"
      :class="{ 'status-img': groupShowType === 'vertical' }"
    >
      <div class="leftsidebar-product_wrap">
        <div class="leftsidebar-product_grid" :class="{'active':!isFilterOpen}">
          <!-- 篩選  -->
          <filter-panel
            v-model:filters="filters"
            :group-data="data"
            @reset-filters="resetFilters"
            :is-filter-open="isFilterOpen"
            @toggle-filter="toggleFilter"
          ></filter-panel>

          <div class="product_wrap">
            <div class="product_container">
              <div
                v-for="departure in filteredDataByGroup"
                class="DEP_area"
                :key="departure.departureName || 'departure-default'"
                v-bind="!dept && ['台中','高雄'].includes(departure.departureName) ? { 'data-departure-name' : getTextWithoutSign (departure.departureName)} : {} "
              >
                <div
                  v-if="!dept && ['台中','高雄'].includes(departure.departureName)"
                  class="DEP_title"
                >
                  {{departure.departureName}}出發
                </div>
                <div class="location_region">
                  <template
                    v-for="area in departure.areas"
                    :key="area.area || 'default-area'"
                  >
                      <template
                        v-for="promotion in area.promotions"
                        :key="(promotion.promotion || 'default-promotion') + (area.area || '')"
                      >
                        <template v-if="promotion.promotion">
                          <div class="block">
                            <location-area
                              :area="area.area"
                              :sub-areas="promotion.subAreas"
                              :isFilterOpen="isFilterOpen"
                              :is-loading="isLoading"
                              :promotion="promotion.promotion"
                              :promotion-data="promotion.promotionData"
                            ></location-area>
                          </div>
                        </template>
                        <template v-else>
                          <location-area
                            :area="area.area"
                            :sub-areas="promotion.subAreas"
                            :isFilterOpen="isFilterOpen"
                            :is-loading="isLoading"
                          ></location-area>
                        </template>
                    </template>
                  </template>
                </div>
              </div>
              <div v-if="filterCount>0" class="noProduct_text-bottom">
                找不到行程？
                <button
                  class=" filter_dialog_btn"
                  @click="mobileFilterPopup=true"
                >
                  重新篩選
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  methods: {
    getTextWithoutSign(text) {
      return getTextWithoutSign(text);
    },
  },
});
